module.exports = __webpack_public_path__ + "static/media/Contact Information.3a9e3240.svg";